import React, { Fragment } from "react";
import { mmStatePhone, mmPhones, MonthsPTBR, AIRLINE_PROGRAMS } from "./enums";
import { isMobile } from "../../../js/components/searchform/utils/common";
import {
	ROUTE_PREFIX_EDIT_OFFER_MOBILE,
	ROUTE_PREFIX_EDIT_OFFER,
	ROUTE_PREFIX_CREATE_OFFER_MOBILE,
	ROUTE_PREFIX_CREATE_OFFER,
	ROUTE_SALE_MILES
} from "./constants";

const jwtDecode = require("jwt-decode");
const moment = require("moment");

export const isValidCellPhone = cellphone => {
	if (!cellphone) return cellphone;
	let numberPhoneWithoutMask = "";
	let regex = /^[0-9]{2}[9]{1}[0-9]{4}[0-9]{4}$/;
	[...cellphone].forEach(n => (!isNaN(parseInt(n)) ? (numberPhoneWithoutMask += n) : true));
	return regex.exec(numberPhoneWithoutMask);
};

export const getUserToken = () => {
	return localStorage.getItem("au");
};

export const returnUserJWT = () => {
	const au = localStorage.getItem("au");
	if (au) {
		const user = jwtDecode(au);
		return user;
	}
	return "";
};

export const isAllFieldsEmpty = (obj, ...fields) => {
	if (!obj) {
		return true;
	}

	let r = fields.reduce((prev, next) => {
		return prev + (obj[next] || "");
	}, "");

	return !r;
};

export const validCreditCardDate = value => {
	if (!value) {
		return false;
	}

	let values = String(value).split("/");

	if (values.length < 2) {
		return false;
	}

	let month = parseInt(values[0]);
	let year = parseInt(values[1]);

	if (month < 1 || month > 12 || year < 18) {
		return false;
	}

	let momentLocally = moment;
	momentLocally.locale("pt-br");

	return momentLocally(new Date(2000 + year, month, 1, 23, 59, 59, 0))
		.subtract(1, "days")
		.isAfter(new Date());
};

/**
 * Retorna o nome do programa tratado
 * ex: Platinum / Black -> Multiplus
 * @param {String} offer offer
 * @returns {String} name
 */
export const getFidelityName = offer => {
	if (!offer) {
		return undefined;
	}

	if (offer.fidelity.airlineAcronym == "Latam") {
		return "Multiplus";
	}

	return offer.fidelity.name;
};

/**
 * Retorna um telefone aleatório com DDD próximo
 * ex: SP
 * @param {String} state estado
 * @returns {String} telefone
 */
export const getPhoneByState = state => {
	let phones = mmStatePhone[state];

	if (!phones) {
		phones = mmPhones.phone61;
	}

	let phone = phones[Math.floor(Math.random() * phones.length)];

	return phone;
};

/**
 * Formata os minutos em HHmm
 * ex: 1h 20min
 * @param {Number} mins minutos
 * @returns {String} diferença entre as datas
 */
export const minutesToHHmm = mins => {
	if (!mins) return "--";

	let h = (mins / 60) | 0,
		m = mins % 60 | 0;

	if (h < 1) return `${m}min`;

	if (m < 1) return `${h}h`;

	return `${h}h ${m}min`;
};

/**
 * Formata datetime para um date amigavel
 * ex: 26 Set (Quarta) • 11:12
 * @param {DateTime} date
 * @returns {String}
 */
export const formatDateTimeToFriendshipDate = date => {
	let momentLocally = moment;
	momentLocally.updateLocale("pt-br", localePTBR);

	let returnDate = momentLocally(date);

	return returnDate.isValid ? returnDate.format("D MMM (dddd) • HH:mm") : "--";
};

/**
 * Retorna o nome do mês
 * ex: Maio
 * @param {Number} monthNumber
 * @returns {String}
 */
export const formatMonthNumberToMonthName = monthNumber => {
	if (!monthNumber) {
		return "-";
	}

	let momentLocally = moment;
	momentLocally.updateLocale("pt-br", localePTBR);
	let monthName = momentLocally(monthNumber, "M").format("MMMM");
	return monthName.charAt(0).toUpperCase() + monthName.slice(1);
};

/**
 * Formata date para uma date local
 * ex: 15/02/1990
 * @param {Date} date
 * @returns {String} data formatada
 */
export const formatDateToLocalDate = date => {
	if (!date) {
		return undefined;
	}

	let momentLocally = moment;
	momentLocally.locale("pt-br");

	let returnDate = momentLocally(date);

	return returnDate.isValid() ? returnDate.format("DD/MM/YYYY") : "--";
};

/**
 * Formata date para uma date local
 * ex: Outubro/2018
 * @param {Date} date
 * @returns {String} data formatada
 */
export const formatDateToMonthStringAndYear = date => {
	let momentLocally = moment;
	momentLocally.locale("pt-br");

	let month = MonthsPTBR[parseInt(momentLocally(date).format("MM"))];
	let year = momentLocally(date).format("YYYY");
	return month + "/" + year;
};

/**
 * Formata date para uma date local
 * ex: 15/02/1990
 * @param {Date} date
 * @returns {String} data formatada
 */
export const formatDateToPortugueseFormat = date => {
	let momentLocally = moment;
	momentLocally.locale("pt-br");

	let returnDate = momentLocally(date);

	return returnDate.isValid() ? returnDate.format("DD/MM/YYYY") : "--";
};

/**
 * Formata date para uma date local com ano de 2 digitos
 * ex: 15/02/90
 * @param {Date} date
 * @returns {String} data formatada
 */
export const formatDateToPortugueseFormatWithTime = date => {
	let momentLocally = moment;
	momentLocally.locale("pt-br");

	let returnDate = momentLocally(date);

	return returnDate.isValid() ? returnDate.format("DD/MM/YYYY • HH:mm:ss") : "--";
};

/**
 * Formata date para uma date local com ano de 2 digitos Espaçado
 * ex: 15/02/90
 * @param {Date} date
 * @returns {String} data formatada
 */
export const formatDateToPortugueseFormatReducedYear = date => {
	let momentLocally = moment;
	momentLocally.locale("pt-br");

	let returnDate = momentLocally(date);

	return returnDate.isValid() ? returnDate.format("DD/MM/YY") : "--";
};

/**
 * Formata date para uma date local com ano de 2 digitos Espaçado
 * ex: 15/02/90
 * @param {Date} date
 * @returns {String} data formatada
 */
export const formatDateToPortugueseFormatReducedYearSpaced = date => {
	let momentLocally = moment;
	momentLocally.locale("pt-br");

	let returnDate = momentLocally(date);

	return returnDate.isValid() ? returnDate.format("DD / MM / YY") : "--";
};

/**
 * Formata date para uma date computacional
 * ex: 1990-01-01
 * @param {Date} date
 * @returns {String} data formatada
 */
export const formatDateToComputerDate = date => {
	let momentLocally = moment;
	momentLocally.locale("pt-br");

	return momentLocally(date, "DD/MM/YYYY").format("YYYY-MM-DD");
};

/**
 * Calcula a difereca de dias de uma data para outra
 * @param {Date} firstDate
 * @param {Date} secondDate
 * @returns {Number} diferenca dos dias
 */
export const getDiffBetweenTwoDates = (firstDate, secondDate) => {
	let first = moment(firstDate);
	let second = moment(secondDate);
	return second.diff(first, "days");
};

/**
 * Verifica se a data informado é antes do dia atual
 * @param {Date} currentDate
 * @returns {Boolean}
 */
export const isTodayBefore = currentDate => {
	let today = moment(new Date());
	let date = moment(currentDate, "YYYY-MM-DD");
	return today.isBefore(date);
};

/**
 * Adiciona dias a data atual
 * @param {Date} currentDate
 * @param {Number} daysToIncrease
 * @returns {String} data com a soma dos dias
 */
export const incDaysToDate = (currentDate, daysToIncrease) => {
	let momentLocally = moment;
	momentLocally.locale("pt-br");

	return momentLocally(currentDate, "YYYY-MM-DD")
		.add(daysToIncrease, "days")
		.toDate();
};

/**
 * Adiciona dias a data atual
 * @param {Date} currentDate
 * @param {Number} daysToDecrease
 * @returns {String} data com a soma dos dias
 */
export const decDaysToDate = (currentDate, daysToDecrease) => {
	let momentLocally = moment;
	momentLocally.locale("pt-br");

	return momentLocally(currentDate, "YYYY-MM-DD")
		.subtract(daysToDecrease, "days")
		.toDate();
};

/**
 * Retorna o última data do mês
 * @param {Date} date
 * @return {String} yyyy-mm-dd
 */
export const getLastDayOfMonth = date => {
	let momentLocally = moment;
	momentLocally.locale("pt-br");

	return momentLocally(date)
		.endOf("month")
		.toDate();
};

/**
 * Retorna o última data do mês
 * @param {Date} date
 * @return {String} yyyy-mm-dd
 */
export const getFirstDayOfMonth = date => {
	let momentLocally = moment;
	momentLocally.locale("pt-br");

	return momentLocally(date)
		.startOf("month")
		.toDate();
};

/**
 * Valida CNPJ
 * @param {String} cnpj
 */
export const validateCNPJ = cnpj => {
	cnpj = cnpj.replace(/[^\d]+/g, "");

	let tamanho;
	let numeros;
	let digitos;
	let soma;
	let pos;
	let resultado;

	if (cnpj == "") return false;

	if (cnpj.length != 14) return false;

	// Elimina CNPJs invalidos conhecidos
	if (
		cnpj == "00000000000000" ||
		cnpj == "11111111111111" ||
		cnpj == "22222222222222" ||
		cnpj == "33333333333333" ||
		cnpj == "44444444444444" ||
		cnpj == "55555555555555" ||
		cnpj == "66666666666666" ||
		cnpj == "77777777777777" ||
		cnpj == "88888888888888" ||
		cnpj == "99999999999999"
	)
		return false;

	// Valida DVs
	tamanho = cnpj.length - 2;
	numeros = cnpj.substring(0, tamanho);
	digitos = cnpj.substring(tamanho);
	soma = 0;
	pos = tamanho - 7;
	for (i = tamanho; i >= 1; i--) {
		soma += numeros.charAt(tamanho - i) * pos--;
		if (pos < 2) pos = 9;
	}
	resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
	if (resultado != digitos.charAt(0)) return false;

	tamanho = tamanho + 1;
	numeros = cnpj.substring(0, tamanho);
	soma = 0;
	pos = tamanho - 7;
	for (i = tamanho; i >= 1; i--) {
		soma += numeros.charAt(tamanho - i) * pos--;
		if (pos < 2) pos = 9;
	}
	resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
	if (resultado != digitos.charAt(1)) return false;

	return true;
};

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
export const getMobileOperatingSystem = userAgent => {
	userAgent = navigator.userAgent || navigator.vendor || window.opera;

	// Windows Phone must come first because its UA also contains "Android"
	/*if (/windows phone/i.test(userAgent)) {
		return "Windows Phone";
	} */

	if (/android/i.test(userAgent)) {
		return "Android";
	}

	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		return "iOS";
	}

	return "";
};

// Utils Locale PT-BR do moment
const localePTBR = {
	monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
	weekdays: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
	longDateFormat: {
		LLLL: "D MMM [(]dddd[)] [•] LT"
	}
};

export const FlatpickrLocalePT = {
	weekdays: {
		shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
		longhand: [
			"Domingo",
			"Segunda-feira",
			"Terça-feira",
			"Quarta-feira",
			"Quinta-feira",
			"Sexta-feira",
			"Sábado"
		]
	},
	months: {
		shorthand: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
		longhand: [
			"Janeiro",
			"Fevereiro",
			"Março",
			"Abril",
			"Maio",
			"Junho",
			"Julho",
			"Agosto",
			"Setembro",
			"Outubro",
			"Novembro",
			"Dezembro"
		]
	},
	rangeSeparator: " até "
};

//download.js v4.2, by dandavis; 2008-2016. [CCBY2] see http://danml.com/download.html for tests/usage
export const makeDownload = (data, strFileName, strMimeType) => {
	var self = window,
		defaultMime = "application/octet-stream",
		mimeType = strMimeType || defaultMime,
		payload = data,
		url = !strFileName && !strMimeType && payload,
		anchor = document.createElement("a"),
		toString = function(a) {
			return String(a);
		},
		myBlob = self.Blob || self.MozBlob || self.WebKitBlob || toString,
		fileName = strFileName || "download",
		blob,
		reader;
	myBlob = myBlob.call ? myBlob.bind(self) : Blob;

	if (String(this) === "true") {
		//reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
		payload = [payload, mimeType];
		mimeType = payload[0];
		payload = payload[1];
	}

	if (url && url.length < 2048) {
		// if no filename and no mime, assume a url was passed as the only argument
		fileName = url
			.split("/")
			.pop()
			.split("?")[0];
		anchor.href = url; // assign href prop to temp anchor
		if (anchor.href.indexOf(url) !== -1) {
			// if the browser determines that it's a potentially valid url path:
			var ajax = new XMLHttpRequest();
			ajax.open("GET", url, true);
			ajax.responseType = "blob";
			ajax.onload = function(e) {
				download(e.target.response, fileName, defaultMime);
			};
			setTimeout(function() {
				ajax.send();
			}, 0); // allows setting custom ajax headers using the return:
			return ajax;
		} // end if valid url?
	} // end if url?

	//go ahead and download dataURLs right away
	if (/^data\:[\w+\-]+\/[\w+\-]+[,;]/.test(payload)) {
		if (payload.length > 1024 * 1024 * 1.999 && myBlob !== toString) {
			payload = dataUrlToBlob(payload);
			mimeType = payload.type || defaultMime;
		} else {
			return navigator.msSaveBlob // IE10 can't do a[download], only Blobs:
				? navigator.msSaveBlob(dataUrlToBlob(payload), fileName)
				: saver(payload); // everyone else can save dataURLs un-processed
		}
	} //end if dataURL passed?

	blob = payload instanceof myBlob ? payload : new myBlob([payload], { type: mimeType });

	function dataUrlToBlob(strUrl) {
		var parts = strUrl.split(/[:;,]/),
			type = parts[1],
			decoder = parts[2] == "base64" ? atob : decodeURIComponent,
			binData = decoder(parts.pop()),
			mx = binData.length,
			i = 0,
			uiArr = new Uint8Array(mx);

		for (i; i < mx; ++i) uiArr[i] = binData.charCodeAt(i);

		return new myBlob([uiArr], { type: type });
	}

	function saver(url, winMode) {
		if ("download" in anchor) {
			//html5 A[download]
			anchor.href = url;
			anchor.setAttribute("download", fileName);
			anchor.className = "download-js-link";
			anchor.innerHTML = "downloading...";
			anchor.style.display = "none";
			document.body.appendChild(anchor);
			setTimeout(function() {
				anchor.click();
				document.body.removeChild(anchor);
				if (winMode === true) {
					setTimeout(function() {
						self.URL.revokeObjectURL(anchor.href);
					}, 250);
				}
			}, 66);
			return true;
		}

		// handle non-a[download] safari as best we can:
		if (/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
			url = url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
			if (!window.open(url)) {
				// popup blocked, offer direct download:
				if (
					confirm(
						"Displaying New Document\n\nUse Save As... to download, then click back to return to this page."
					)
				) {
					location.href = url;
				}
			}
			return true;
		}

		//do iframe dataURL download (old ch+FF):
		var f = document.createElement("iframe");
		document.body.appendChild(f);

		if (!winMode) {
			// force a mime that will download:
			url = "data:" + url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
		}
		f.src = url;
		setTimeout(function() {
			document.body.removeChild(f);
		}, 333);
	} //end saver

	if (navigator.msSaveBlob) {
		// IE10+ : (has Blob, but not a[download] or URL)
		return navigator.msSaveBlob(blob, fileName);
	}

	if (self.URL) {
		// simple fast and modern way using Blob and URL:
		saver(self.URL.createObjectURL(blob), true);
	} else {
		// handle non-Blob()+non-URL browsers:
		if (typeof blob === "string" || blob.constructor === toString) {
			try {
				return saver("data:" + mimeType + ";base64," + self.btoa(blob));
			} catch (y) {
				return saver("data:" + mimeType + "," + encodeURIComponent(blob));
			}
		}

		// Blob but not URL support:
		reader = new FileReader();
		reader.onload = function(e) {
			saver(this.result);
		};
		reader.readAsDataURL(blob);
	}
	return true;
};

export const fidelityIsNational = fidelityId => {
	return fidelityId && fidelityId <= 6 && fidelityId != 2;
	// Platinum 1 || Multiplus 3 || Smiles 4 || Azul 5 || Avianca 6
};

// UUID hash generator
const CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
export const uuid = () => {
	let chars = CHARS,
		uuid = new Array(36),
		rnd = 0,
		r;
	for (var i = 0; i < 36; i++) {
		if (i == 8 || i == 13 || i == 18 || i == 23) {
			uuid[i] = "-";
		} else if (i == 14) {
			uuid[i] = "4";
		} else {
			if (rnd <= 0x02) rnd = (0x2000000 + Math.random() * 0x1000000) | 0;
			r = rnd & 0xf;
			rnd = rnd >> 4;
			uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
		}
	}
	return uuid.join("");
};

export const needRanking = offer => {
	return (
		!offer.invalidRank &&
		!offer.international &&
		offer.quant >= offer.fidelity.valMinMiles &&
		(offer.status == 2 || offer.status == 3 || offer.status == 7) &&
		offer.quant > 0 &&
		offer.price > 0
	);
};

export const fidelityHasAverage = fidelityId => {
	return fidelityId == 1 || fidelityId == 3 || fidelityId == 5 || fidelityId == 4 || fidelityId == 21;
	// Platinum || Multiplus || Azul || Smiles || TAP
};

/**
 * Quando possui a oferta da pra validar dinamicamente a média por já possuir o campo valMinMiles
 * @param {Object} offer offer com fidelity
 */
export const showAverage = offer => {
	return (
		offer.averageMiles >= offer.fidelity.valMinMiles &&
		fidelityHasAverage(offer.fidelity.id) &&
		offer.quant >= 60000
	);
};

/**
 * Quando possui a oferta da pra validar dinamicamente a média por já possuir o campo valMinMiles
 * @param {Object} offer offer com fidelity
 */
export const showAverageHome = offer => {
	return (
		(offer.averageMiles > offer.fidelity.valMinMiles || offer.quant >= 60000) &&
		fidelityHasAverage(offer.fidelity.id)
	);
};

export const findAverageMessage = (averageMiles, averageMilesSuggest, fidelity, percent) => {
	let green = {
			color: "green",
			text: (
				<React.Fragment>
					<p>
						<strong className="message-title green-average">
							Esta é a melhor média possível para a sua oferta!
						</strong>
					</p>
					<p>
						Você pode informar a média de milhas por passageiro que deseja vender na MaxMilhas.
						Cuidaremos para que a média, ao final de suas vendas, seja igual ou superior a
						quantidade informada.
					</p>
				</React.Fragment>
			)
		},
		blue = {
			color: "blue",
			text: (
				<React.Fragment>
					<p>
						<strong className="message-title blue-average">
							Tudo bem, tentaremos vender dentro dessa média.
						</strong>
					</p>
					<p>
						Você pode informar a média de milhas por passageiro que deseja vender na MaxMilhas.
						Cuidaremos para que a média, ao final de suas vendas, seja igual ou superior a
						quantidade informada.
					</p>
				</React.Fragment>
			)
		},
		yellow = {
			color: "yellow",
			text: (
				<React.Fragment>
					<p>
						<strong className="message-title yellow-average">
							Atenção! Médias maiores que 15.000 milhas podem demorar mais para serem vendidas.
						</strong>
					</p>
					<p>
						Você pode informar a média de milhas por passageiro que deseja vender na MaxMilhas.
						Cuidaremos para que a média, ao final de suas vendas, seja igual ou superior a
						quantidade informada.
					</p>
				</React.Fragment>
			)
		},
		grey = {
			color: "grey",
			text: (
				<React.Fragment>
					<p>
						Você pode informar a média de milhas por passageiro que deseja vender na MaxMilhas.
						Cuidaremos para que a média, ao final de suas vendas, seja igual ou superior a
						quantidade informada.
					</p>
				</React.Fragment>
			)
		};

	let cartaoVermelhoGreen = {
			color: "green",
			text: (
				<React.Fragment>
					<p>
						<strong className="message-title green-average">
							Esta é a melhor média possível para a sua oferta!
						</strong>
					</p>
					<p>
						Cuidaremos para que a média, ao final de suas vendas, seja igual ou superior a
						quantidade informada.
					</p>
				</React.Fragment>
			)
		},
		cartaoVermelhoGrey = {
			color: "grey",
			text: (
				<React.Fragment>
					<p>
						Caso a sua média seja diferente de 25.000 milhas por passagem, seu preço será comparado
						aos preços da categoria normal (Latam e Gold). Dessa forma, seu valor será menos
						competitivo e suas milhas irão demorar mais para serem utilizadas.
					</p>
				</React.Fragment>
			)
		};

	let averageMessage = grey;

	if (averageMiles < 3500) {
		return averageMessage;
	}

	if (fidelity && fidelity.value == 1) {
		// Cartao vermelho (Platinum)
		if (averageMilesSuggest == averageMiles) {
			averageMessage = cartaoVermelhoGreen;
		} else if (averageMiles > 25000) {
			averageMessage = {
				color: "red",
				text: (
					<React.Fragment>
						<p>
							<strong className="message-title red-average">
								Cuidado! Esta média representa apenas {percent}% das nossas vendas. Nossa sugestão é
								25.000 milhas.
							</strong>
						</p>
						<p>
							Caso a sua média seja diferente de 25.000 milhas por passagem, seu preço será
							comparado aos preços da categoria normal (Latam e Gold). Dessa forma, seu valor será
							menos competitivo e suas milhas irão demorar mais para serem utilizadas.
						</p>
					</React.Fragment>
				)
			};
		} else {
			averageMessage = cartaoVermelhoGrey;
		}
	} else {
		if (averageMilesSuggest == averageMiles) {
			averageMessage = green;
		} else {
			if (averageMiles <= 15000) {
				averageMessage = blue;
			} else if (averageMiles > 15000 && averageMiles <= 25000) {
				if (averageMilesSuggest > averageMiles) {
					averageMessage = blue;
				} else {
					averageMessage = yellow;
				}
			} else if (averageMiles > 25000) {
				averageMessage = {
					color: "red",
					text: (
						<React.Fragment>
							<p>
								<strong className="message-title red-average">
									Atenção! Esta média representa apenas {percent}% das nossas vendas. Sugerimos que
									você diminua a média de milhas por passageiro para que sua venda seja mais rápida.
								</strong>
							</p>
							<p>
								Podemos emitir passagens com quantidade de milhas menor ou maior do que a média
								informada. No fim das vendas, a média de milhas por passageiro será igual ou
								superior à desta oferta.
							</p>
						</React.Fragment>
					)
				};
			} else {
				averageMessage = grey;
			}
		}
	}

	return averageMessage;
};

export const getNameFirstsWords = name => {
	let nameArray = name.split(" ");

	return nameArray.length > 1
		? nameArray[0].charAt(0) + nameArray[nameArray.length - 1].charAt(0)
		: nameArray[0].charAt(0) + nameArray[0].charAt(1);
};

/**
 * Valida se o relacionamento está com status em negociação ou em análise
 * Utilizado no simulador de ofertas
 * @param {String} relationship relationship
 * @returns {Boolean} boolean
 */
export const isRelationshipStatusPendentOrNegotiation = relationship => {
	return relationship.status.status === "P" || relationship.status.status === "N";
};

/**
 * Valida se o relacionamento está com status inativo
 * Utilizado pra exibir ou não o botão de cancelar vinculo
 * @param {String} relationship relationship
 * @returns {Boolean} boolean
 */
export const isRelationshipStatusInactive = relationship => {
	return relationship.status.status === "I";
};

/**
 * Valida se o relacionamento está com status ativo
 * Utilizado pra exibir ou não o botão de cancelar vinculo
 * @param {String} relationship relationship
 * @returns {Boolean} boolean
 */
export const isRelationshipStatusActive = relationship => {
	return relationship.status.status === "A";
};

/**
 * Calcula o minimo real da faixa dinâmica (bônus)
 * @param {Integer} relationship relationship
 * @returns {Boolean} boolean
 */
export const getStartAverage = (quantMiles, countAllowedSales, startAverage, endAverage) => {
	let minAverage = startAverage;
	while (minAverage <= endAverage) {
		if (Math.floor(quantMiles / minAverage) > countAllowedSales) {
			minAverage += 500;
		} else {
			break;
		}
	}
	return minAverage;
};

/**
 * Verifica qual o acrônimo para retornar qual a url correta no redirecionamento
 * Apenas para nacionais
 * @param {String} acronym acronym
 * @returns {String} endpoint url
 */
export const getCorrectUrlByAcronym = acronym => {
	acronym = acronym ? acronym.toLowerCase() : "";
	switch (acronym) {
		case "latam":
			return "/vender-milhas/latam-multiplus";
		case "azul":
			return "/vender-milhas/azul-tudoazul";
		case "gol":
			return "/vender-milhas/gol-smiles";
		default:
			return "/vender-milhas";
	}
};

/**
 * Faz o scroll da tela para determinada distância e componente passados por parâmetro
 * @param {String} component Passar o querySelector que deseja ser a referência para o scroll
 * @param {Number} distance Passar a distância do topo que deseja - 80 é o default
 */
export const scrollToComponent = (
	component,
	distance = 80,
	onlyMobile = false,
	hasInnerScroll = false
) => {
	if (onlyMobile && !isMobile()) {
		return;
	}

	setTimeout(() => {
		let base = document.querySelector(component);
		let element = base;

		window.scrollTo({
			top: base.getBoundingClientRect().top + window.scrollY - distance,
			behavior: "smooth"
		});

		if (hasInnerScroll) {
			while (element && element.tagName !== "BODY") {
				element.scrollTo({
					top: base.getBoundingClientRect().top + element.scrollTop - distance,
					behavior: "smooth"
				});
				element = element.parentNode;
			}
		}
	}, 200);
};

export const handleFidelityNameToPath = program => {
	if (!program.fidelityName) {
		return "";
	}

	let name = program.international === "1" ? program.acronym : program.fidelityName;
	name = name.replace(/[\W_]+/g, "-");

	return name.toLowerCase();
};

export const redirectNewOffer = (history, edit) => {
	if (!history) {
		return;
	}

	const routeEdit = isMobile() ? ROUTE_PREFIX_EDIT_OFFER_MOBILE : ROUTE_PREFIX_EDIT_OFFER;
	const routeCreate = isMobile() ? ROUTE_PREFIX_CREATE_OFFER_MOBILE : ROUTE_PREFIX_CREATE_OFFER;

	history.push(edit ? routeEdit : routeCreate);
};

export const formatPhone = value => {
	try {
		const length = value.length;
		let phone;

		if (length === 10) {
			phone = value.match(/(\d{2})(\d{4})(\d{4})/);
		} else if (length === 11) {
			phone = value.match(/(\d{2})(\d{5})(\d{4})/);
		}

		return "(" + phone[1] + ") " + phone[2] + "-" + phone[3];
	} catch (e) {
		console.error(`Não foi possível aplicar a máscara no telefone ${value}. Erro: ${e}`);
	}

	return value;
};

/**
 * Informa o ID do programa de fidelidade de acordo com o nome
 * @param {*} acronym
 */
// Get fidelity id from acronym
const getFidelityId = acronym => {
	switch (acronym) {
		case "latam":
			return 3;
		case "gol":
			return 4;
		case "azul":
			return 5;
		default:
			return null;
	}
};

/**
 * Formata o payload da requisição getPricesQuickSale()
 * @param {*} result
 */
export const formatPricesQuickSale = result => {
	const newPrices = [];

	result.data.forEach(price => {
		const newPrice = {
			id_airline_program: getFidelityId(price.acronym),
			acronym: price.acronym,
			price: price.ruleSet[0].fastSalePrice.value
		};

		price.ruleSet[0].rules.forEach(rule => {
			if (rule.variable === "miles") {
				newPrice.minMilesAmount = rule.params.filter(param => param.name === "minimal")[0].value;
				newPrice.maxMilesAmount = rule.params.filter(param => param.name === "maximum")[0].value;
			}
			if (rule.variable === "ratio") newPrice.maxAverageMiles = rule.params[0].value;
		});

		newPrices.push(newPrice);
	});

	return { ...result, data: newPrices };
};

/**
 * Formata o payload da requisição getPricesForwardPayment()
 * @param {*} result
 */
export const formatPricesForwardPayment = result => {
	const newPrices = [];

	result.data.forEach(price => {
		const newPrice = {
			id_airline_program: getFidelityId(price.acronym),
			acronym: price.acronym,
			price: price.ruleSet[0].price.minimal
		};

		price.ruleSet[0].rules.forEach(rule => {
			if (rule.variable === "miles") {
				newPrice.minMilesAmount = rule.params.filter(param => param.name === "minimal")[0].value;
				newPrice.maxMilesAmount = rule.params.filter(param => param.name === "maximum")[0].value;
			}
			if (rule.variable === "ratio") newPrice.maxAverageMiles = rule.params[0].value;
		});

		newPrices.push(newPrice);
	});

	return { ...result, data: newPrices };
};

/**
 * Verifica se o programa passado é Latam.
 * @param {string} data - O id do programa
 * @returns {boolean} true se estiver vazio ou não existir
 */
export const isLatam = (programId) => {
	return programId === AIRLINE_PROGRAMS.PLATINUM.id ||
	programId === AIRLINE_PROGRAMS.LATAM_PASS.id
}

// Redirects
export const redirectToMilesSale = () => {
	window.location.href = ROUTE_SALE_MILES;
}
